import React, { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom';
import { firestore } from '../../../firebase';
import ImagePickerReturnUrl from '../Media/templates/ImagePickerReturnUrl';
import SearchTeams from '../../Public/FootballAPI/Search/SearchTeams'
import LeagueSelector from '../LeaguesAPI/LeagueSelector';

function EditTransfer() {

    const { id } = useParams();

    const [name, setName] = useState("");
    const [image, setImage] = useState("");
    const [transferSum, setTransferSum] = useState(0);

    const [toClubName, setToClubName] = useState("");
    const [fromClubName, setFromClubName] = useState("");
    const [fromClubId, setFromClubId] = useState("");
    const [toClubId, setToClubId] = useState("");

    const [fromLeagueId, setFromLeagueId] = useState("");
    const [toLeagueId, setToLeagueId] = useState("");

    const [show, setShow] = useState(false)

    const [showTeamSelector, setShowTeamSelector] = useState(false)
    const [showTextEdit, setShowTextEdit] = useState(false)

    const [date, setDate] = useState("");
    const [message, setMessage] = useState("");

    const [fromTeam, setFromTeam] = useState()
    const [toTeam, setToTeam] = useState()

    const [fromLeague, setFromLeague] = useState()
    const [toLeague, setToLeague] = useState()

    useEffect(() => {

        try {
            const transferRef = firestore.collection("transfers").doc(id);
            transferRef.onSnapshot(doc => {
                const transfer = { id: doc.id, ...doc.data() }
                setName(transfer.player_name);
                setImage(transfer.image);
                setTransferSum(transfer.transfer_sum);
                setFromClubName(transfer.from_club_name);
                setToClubName(transfer.to_club_name);
                setFromClubId(transfer.from_club);
                setToClubId(transfer.to_club);
                setFromLeagueId(transfer.from_league_id);
                setToLeagueId(transfer.to_league_id);
                setDate(transfer.date);
            })
        } catch (error) {

        }

    }, [id])

    useEffect(() => {

        if (fromTeam) {
            console.log(fromTeam)
            setFromClubName(fromTeam.name)
            setFromClubId(fromTeam.team_id)
        }
        if (toTeam) {
            console.log(toTeam)
            setToClubName(toTeam.name)
            setToClubId(toTeam.team_id)
        }

    }, [fromTeam, toTeam])

    useEffect(() => {
        console.log(toLeague, fromLeague)
        if (toLeague) {
            setToLeagueId(toLeague?.league_id)
        }
        if (fromLeague) {
            setFromLeagueId(fromLeague?.league_id)
        }

    }, [toLeague, fromLeague])

    async function editTransferHandler(e) {
        e.preventDefault();
        try {
            const transferRef = firestore.collection("transfers").doc(id);
            const transferData = {
                player_name: name,
                image,
                transfer_sum: +transferSum,
                from_club_name: fromClubName,
                to_club_name: toClubName,
                from_club: fromClubId,
                to_club: toClubId,
                to_league_id: toLeagueId,
                from_league_id: fromLeagueId,
                date

            }
            transferRef.update(transferData)
            setMessage("Lagret endringer!")
        } catch (error) {
            setMessage(error.message)
        }
    }

    return (
        <div className="container my-4">
            <Link to="/add-transfer" className="btn btn-success"><i className="fas fa-plus"></i> Ny overgang</Link>

            <form onSubmit={editTransferHandler}>

                <label>Spiller navn</label>
                <input value={name} onChange={e => setName(e.target.value)} className="form-control mb-2" placeholder="Spillers navn" />

                <label>Bilde</label>
                <input value={image} onChange={e => setImage(e.target.value)} className="form-control mb-2" />

                {image && <img style={{ maxWidth: "40vw" }} src={image} className="img-fluid" alt="" />}
                <div className="btn btn-success btn-block" style={{ cursor: "pointer" }} onClick={() => setShow(true)}>Velg bilde url</div>

                <label>Dato for overgang</label>
                <input type="date" className="form-control mb-2" value={date} onChange={e => setDate(e.target.value)} />

                <label>Overgangssum</label>
                <input type="number" value={transferSum} onChange={e => setTransferSum(e.target.value)} className="form-control mb-2" />
                {!showTeamSelector && <div className="my-3"><button className="btn btn-secondary" onClick={() => setShowTeamSelector(true)}>Finn lag</button></div>}
                {showTeamSelector &&
                    <React.Fragment>
                        <button className="btn btn-secondary" onClick={() => setShowTeamSelector(false)}>Lukk</button>
                        <p>Søk hjemmelag</p>
                        <SearchTeams
                            selectedTeam={fromTeam}
                            setSelectedTeam={setFromTeam}
                            type="teamSelector"
                            teamName={""}
                        />
                        <p>Søk bortelag</p>
                        <SearchTeams
                            selectedTeam={toTeam}
                            setSelectedTeam={setToTeam}
                            type="teamSelector"
                            teamName={""}
                        />
                    </React.Fragment>
                }
                {!showTextEdit && <button className="btn btn-block btn-info" onClick={() => setShowTextEdit(true)}>Vis manuel redigering</button>}
                {showTextEdit && (
                    <React.Fragment>
                        <button className="btn btn-block btn-info" onClick={() => setShowTextEdit(false)}>Lukk</button>
                        <label>Fra klubb navn:</label>
                        <input value={fromClubName} onChange={e => setFromClubName(e.target.value)} className="form-control mb-2" placeholder="Fra klubb navn" />
                        <label>Til klubb navn</label>
                        <input value={toClubName} onChange={e => setToClubName(e.target.value)} className="form-control mb-2" placeholder="Til klubb navn" />

                        <label>Fra klubb id</label>
                        <input value={fromClubId} onChange={e => setFromClubId(e.target.value)} className="form-control mb-2" placeholder="Fra klubb id" />
                        <label>Til klubb id</label>
                        <input value={toClubId} onChange={e => setToClubId(e.target.value)} className="form-control mb-2" placeholder="Til klubb id" />

                        <label>Fra liga ID</label>
                        <input value={fromLeagueId} onChange={e => setFromLeagueId(e.target.value)} className="form-control mb-2" placeholder="Fra liga ID" />
                        <label>Til lige ID</label>
                        <input value={toLeagueId} onChange={e => setToLeagueId(e.target.value)} className="form-control mb-2" placeholder="Til liga ID" />
                    </React.Fragment>
                )}

                <label>Velg fra liga id</label>
                <LeagueSelector league={fromLeague} setLeague={setFromLeague} />
                <label>Velg til liga id</label>
                <LeagueSelector league={toLeague} setLeague={setToLeague} />

                {message && <div className="alert alert-success">{message}</div>}
                <button className="btn btn-primary btn-rounded">Lagre</button>

            </form>
            <ImagePickerReturnUrl show={show} setShow={setShow} imageUrl={image} setImageUrl={setImage} />
        </div>
    )
}
export default EditTransfer